module.exports = __webpack_public_path__ + "assets/img/18_1869.5fac202b.jpg";